import Dashboard from "../../../components/@dashboard/Dashboard"

import { routeTypes } from "../../../hooks/useSystemRoutes"

export default function DashboardPage() {

  return (
    <Dashboard 
      routeType={routeTypes.driver}
    />
  )
}